/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：mqtt
 *
 * 作成者：2022/03/23 ノア）虞
 * 最終修正者：2022/03/23 ノア）虞
 *
 */

import Cookies from 'js-cookie'

/**
 * クッキーを設定する
 *
 * @param {string} name キー
 * @param {string} value 値
 */
export function setCookie(name: string, value: string): void {
  if (!name) return

  Cookies.set(name, value)
}

/**
 * クッキーを取得する
 *
 * @param {string} name キー
 * @returns {string} クッキーの値
 */
export function getCookie(name: string): string {
  return Cookies.get(name) || ''
}

/**
 * クッキーを削除する
 *
 * @param {string} name キー
 */
export function removeCookie(name: string): void {
  if (!name) return

  Cookies.remove(name)
}

/**
 * クッキーの有効期限を更新する
 *
 * @param {string} name キー
 */
export function updateCookieExpires(name: string): void {
  if (!name) return

  const value = getCookie(name)
  if (!value) return

  setCookie(name, value)
}
